module.exports = __webpack_public_path__ + "static/BDRmono2006-9e467ff9b3273278be9ea3d21a5afb60.woff";